// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {store} from './store/store'

import {upperFirst} from 'lodash-es'
import {camelCase} from 'lodash-es'


 //Initialize Google Maps
import {Loader, LoaderOptions} from 'google-maps';
const apiKey = "AIzaSyBC_G_lppmfVv5mfrZa0w_MiJmV-jOh0m8";
//const apiKey = "AIzaSyAfYKb6xE0V8ic6Y98L09IdzgDc2ID7LL0";
const mapOptions = {
  libraries : ["places"],
  channel : "testing",
  region : "US",
  language : "en"
};


import vueHeadful from 'vue-headful';
Vue.component('vue-headful', vueHeadful);

import VueCompositionAPI from '@vue/composition-api'
Vue.use(VueCompositionAPI);
import {reactive} from '@vue/composition-api'

import { Datetime } from 'vue-datetime';
Vue.component('datetime', Datetime);

import VueFlatPickr from 'vue-flatpickr-component';
require('flatpickr/dist/flatpickr.css');
Vue.use(VueFlatPickr);

import AsyncComputed from 'vue-async-computed'
Vue.use(AsyncComputed)


const google = new Loader(apiKey, mapOptions);
Vue.prototype.$googlePromise = google.load();

Vue.prototype.$strings = reactive({});

import axios from 'axios';
import strings from './strings.js';
Vue.prototype.$strings = reactive(strings);
axios.get("/api/strings.json").then(response => {
  if (!response.data && typeof response.data === "object") {
    throw "string data not found";
  } else {
    Object.assign(Vue.prototype.$strings, response.data)
  }
});


Vue.prototype.$auth = reactive({loggedIn: false, username: null});

//TODO Vue.prototype.$currentLoaction =


Vue.config.productionTip = false

// eslint-disable-next-line no-undef
const requireComponent = require.context(
  // The relative path of the components folder
  './components',
  // Whether or not to look in subfolders
  true,
  // The regular expression used to match base component filenames
  /\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
})

import {ModuleRegistry} from '@ag-grid-community/core'
import {ClientSideRowModelModule} from "@ag-grid-community/client-side-row-model";
ModuleRegistry.registerModules([ClientSideRowModelModule]);

import VueSanitize from "vue-sanitize";
Vue.use(VueSanitize, {allowedTags: ['br', 'i', 'strong']});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',

  mounted: function () {
  },

  results: {}
});



